import script from "./OAuthLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./OAuthLogin.vue?vue&type=script&setup=true&lang=js"

import "./OAuthLogin.vue?vue&type=style&index=0&id=4d26de3b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d26de3b"]])

export default __exports__